import { render } from "./DealNote.vue?vue&type=template&id=4fb3ed1b"
import script from "./DealNote.vue?vue&type=script&lang=js"
export * from "./DealNote.vue?vue&type=script&lang=js"

import "./DealNote.vue?vue&type=style&index=0&id=4fb3ed1b&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/smartsim-ui-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__